import React from 'react';
import { Check, X } from 'lucide-react';
export function ProTools() {
  return <section className="bg-navy text-white py-12" data-id="element-199">
      <div className="max-w-md mx-auto px-4" data-id="element-200">
        <div className="text-center mb-8" data-id="element-201">
          <h2 className="text-[28px] font-extrabold mb-3" data-id="element-202">
            Qué vas a obtener con el PLAN PRO
          </h2>
          <p className="text-gray-light text-[15px]" data-id="element-203">
            La diferencia entre tener partituras sueltas y un sistema completo
            para tu aula
          </p>
        </div>

        {/* Comparison Mobile Stack */}
        <div className="flex flex-col gap-4 mb-10" data-id="element-204">
          {/* Left Column (Without PRO) */}
          <div className="bg-white text-navy p-5 rounded-2xl border border-gray-200" data-id="element-205">
            <h3 className="font-bold text-sm text-red-600 mb-4 flex items-center gap-2" data-id="element-206">
              <X className="w-4 h-4" data-id="element-207" /> SI NO TENÉS EL PLAN PRO
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-208">
              <li className="flex items-start gap-2 text-gray-600" data-id="element-209">
                <span className="shrink-0 mt-0.5" data-id="element-210">•</span>
                <span data-id="element-211">Solo tenés el repertorio en PDF</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600" data-id="element-212">
                <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-213" />
                <span data-id="element-214">Partituras básicas a una sola voz</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600" data-id="element-215">
                <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-216" />
                <span data-id="element-217">Armás los ensayos de ensamble sin backing tracks</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600" data-id="element-218">
                <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-219" />
                <span data-id="element-220">Sin planificación alineada a NAP</span>
              </li>
              <li className="flex items-start gap-2 text-gray-600" data-id="element-221">
                <X className="w-4 h-4 text-red-500 shrink-0 mt-0.5" data-id="element-222" />
                <span data-id="element-223">Sin actualizaciones futuras</span>
              </li>
            </ul>
          </div>

          {/* Right Column (With PRO) */}
          <div className="bg-violet text-white p-5 rounded-2xl border-2 border-turquoise relative" data-id="element-224">
            <div className="absolute -top-3 right-4 bg-turquoise text-white text-[10px] font-bold px-2 py-1 rounded-full" data-id="element-225">
              RECOMENDADO
            </div>
            <h3 className="font-bold text-sm text-turquoise mb-4 flex items-center gap-2" data-id="element-226">
              <Check className="w-4 h-4" data-id="element-227" /> SI TENÉS EL PLAN PRO
            </h3>
            <ul className="space-y-3 text-sm" data-id="element-228">
              <li className="flex items-start gap-2" data-id="element-229">
                <span className="shrink-0 mt-0.5" data-id="element-230">•</span>
                <span data-id="element-231">Tenés un sistema completo para tu aula</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-232">
                <Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-233" />
                <span data-id="element-234">Arreglos a 2 voces para ensamble</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-235">
                <Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-236" />
                <span data-id="element-237">Pistas de acompañamiento (backing tracks)</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-238">
                <Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-239" />
                <span data-id="element-240">Planificación NAP + certificados de participación</span>
              </li>
              <li className="flex items-start gap-2" data-id="element-241">
                <Check className="w-4 h-4 text-turquoise shrink-0 mt-0.5" data-id="element-242" />
                <span data-id="element-243">Acceso a futuras actualizaciones</span>
              </li>
            </ul>
          </div>
        </div>

        {/* 3 PRO Cards */}
        <div className="space-y-4" data-id="element-244">
          <div className="bg-navy-light border border-white/10 p-5 rounded-2xl" data-id="element-245">
            <div className="text-2xl mb-3" data-id="element-246">🎶</div>
            <h4 className="font-bold text-lg mb-2" data-id="element-247">
              PLAN PRO #1 — Arreglos a 2 Voces para Ensamble
            </h4>
            <p className="text-sm text-gray-light leading-relaxed" data-id="element-248">
              Partituras con segunda voz lista para que todo el curso toque en
              conjunto, dividido en dos grupos. Ideal para actos y muestras.
            </p>
          </div>
          <div className="bg-navy-light border border-white/10 p-5 rounded-2xl" data-id="element-249">
            <div className="text-2xl mb-3" data-id="element-250">🔊</div>
            <h4 className="font-bold text-lg mb-2" data-id="element-251">
              PLAN PRO #2 — Pistas de Acompañamiento (Backing Tracks)
            </h4>
            <p className="text-sm text-gray-light leading-relaxed" data-id="element-252">
              Guía de uso de pistas por canción y tomo, con instrucciones de
              tempo y cuenta regresiva, para practicar y presentar con música de
              fondo.
            </p>
          </div>
          <div className="bg-navy-light border border-white/10 p-5 rounded-2xl" data-id="element-253">
            <div className="text-2xl mb-3" data-id="element-254">📋</div>
            <h4 className="font-bold text-lg mb-2" data-id="element-255">
              PLAN PRO #3 — Planificación NAP + Certificados
            </h4>
            <p className="text-sm text-gray-light leading-relaxed" data-id="element-256">
              Planificación curricular alineada a los Núcleos de Aprendizaje
              Prioritarios, más modelos de certificados de participación listos
              para imprimir.
            </p>
          </div>
        </div>
      </div>
    </section>;
}